/*************************************************/
/* HEADER                                        */
/*************************************************/
export function header(body) {
    let headerElement;
    const headerSelector = '.header',
    headerStickyClass = 'header-sticky';
    let scrollTimer;
    
    const setStickyHeader = () => {
        const top = window.pageYOffset || document.documentElement.scrollTop
        if (top > headerElement.offsetHeight / 2) {
            body.classList.add(headerStickyClass);
        } else {
            body.classList.remove(headerStickyClass);
        }
    }
    
    const init = () => {
        headerElement = document.querySelector(headerSelector);

        // Sticky header
        setStickyHeader();
            window.addEventListener('scroll', e => {
                clearTimeout(scrollTimer);
                scrollTimer = setTimeout(function () {
                    setStickyHeader();
                }, 10);
            });
    };

    init();

}

